
const num = '1234567890'
const a = 'abcdefghijklmnopqrstuvwxyz'
const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const aln = num+a
const Aln = aln+A
const voc = 'aeiou'
const VOC = 'AEIOU'
const con = 'bcdfghjklmnpqrstvwxyz'
const CON = 'BCDFGHJKLMNPQRSTVWXYZ'
const b64 = "_abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789."
const b58 = "abcdefghijklmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789"
const sc = '~`!@#$%^&*()_-+={}[]|\\:;"\'<>?,./'
const sc_red = '!@#$%&*+=:?.'
const full = Aln + sc
const fr = b58 + sc_red

const pat_nice = [con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc]
const pat_haiku = [con,voc,con,voc,con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc,con,voc,con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc,con,voc,con,voc]
const pat_shorthaiku = [con,voc,con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc,con,voc,con,voc,con,voc, '-', con,voc,con,voc,con,voc,con,voc]

const passy2 = [CON, voc, con, con, voc, con, num, '-', con+CON, voc, con, con, voc, con,  num, '-', b58, fr, fr, fr, fr, fr, fr, fr, fr]

export const patterns = {
    passy1 : [b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64,b64],
    passy2 : passy2,
    p20b58 : [b58,b58,b58,b58, b58,b58,b58,b58, b58,b58,b58,b58, b58,b58,b58,b58, b58,b58,b58,b58],
    nice : pat_nice,
    haiku : pat_haiku,
    shorthaiku : pat_shorthaiku,
    apple : [con,voc,con,con,voc,con, num, '-', con,voc,con,con,voc,con, num, '-', con,voc,con,con,voc,con, num],
    nice_s : [con,voc,con,voc,con,voc, ' ', con,voc,con,voc,con,voc,' ', con,voc,con,voc,con,voc, ' ', num],
    nice_n : pat_nice.concat(['-', num]),
    haiku_n : pat_haiku.concat(['-', num]),
    shorthaiku_n : pat_shorthaiku.concat(['-', num]),
    full20: [full,full,full,num,full,a,full,A,full,sc,full,full,full,full,full,full,full,full,full,full],
    full24: [full,full,full,num,full,a,full,A,full,sc,full,full,full,full,full,full,full,full,full,full,full,full,full,full]
}

export function pattern_bits_of_security(pat){
    return pat.map(x => Math.log2(x.length)).reduce((a,b) => a+b)
}
	


export function bytes_to_pwd(b, pat){
    let i = bufToBn(b)
    var pwd = ''
    for (var cl of pat){
        let cll = BigInt(cl.length)
        var c = i%cll
        pwd += cl[c]
        i = i/cll
    }
    return pwd
}


export function entropy(value){
    let res 
    
    if (value) {
        var combcnt = 0.0
        if(/\d+/.test(value)){
            combcnt += 10.
        }
        if(/[A-Z]+/.test(value)){
            combcnt += 26.
        }
        if(/[a-z]+/.test(value)){
            combcnt += 26.
        }
        if(/[@#$%^&*()\[\]{}'"\\|<>\/]+/.test(value)){
            combcnt += 5. + 7. + 20.
        }else{
            if(/[_+\-=;:]+/.test(value)){
                combcnt += 5. + 7.
            }else{
                if(/[\s,.!?]+/.test(value)){
                    combcnt += 5.
                }
            }
        }

        res = value.length * Math.log2(combcnt)
    }else{
        res = 0
    } 
    return res
}

export function buf2hex(buffer) { // buffer is an ArrayBuffer
    return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
}

function bnToBuf(bn) {
    var hex = BigInt(bn).toString(16);
    if (hex.length % 2) { hex = '0' + hex; }
  
    var len = hex.length / 2;
    var u8 = new Uint8Array(len);
  
    var i = 0;
    var j = 0;
    while (i < len) {
      u8[i] = parseInt(hex.slice(j, j+2), 16);
      i += 1;
      j += 2;
    }
  
    return u8;
}

function bufToBn(buf) {
    var hex = [];
    var u8 = Uint8Array.from(buf);

    u8.forEach(function (i) {
        var h = i.toString(16);
        if (h.length % 2) { h = '0' + h; }
        hex.push(h);
    });

    return BigInt('0x' + hex.join(''));
}